<template>
  <div>
    <v-dialog v-model="dialogyetki" persistent width="500">
      <v-card color="primary" dark>
        <v-card-text>
          <v-layout align-center="" align-start row wrap fill-height="">
            <v-flex pa-2 xs1 sm1 md1>
              <v-icon large color="white">fingerprint</v-icon>
            </v-flex>
            <v-flex pa-3 xs11 sm11 md11>
              <span class="subheading"> {{this.mesaj}} </span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="islem==0" color="white" flat @click="oncekisayfa()"> {{ $t('Previous-Page') }} </v-btn>
          <v-btn color="white" v-if="islem==1" flat @click="sirketsecimi()">{{$t('Select-Main-Company')}}</v-btn>
          <v-btn color="white" v-if="islem==2" flat @click="cikisyap()">{{$t('Log-Out')}}</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    props: ["value"],
    components: {

    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    methods: {
      oncekisayfa() {
        this.dialogyetki = false
        this.resolve(true);
      },
      sirketsecimi() {
        this.resolve(false);
        var url = '#/anasirket'

        window.open(url, '_self')

      },
      cikisyap() {

        auth.logout()


      },

      open(mesaj, islem) {

        if (islem == null || islem == '') {
          islem = 0
        }
        this.islem = islem
        this.mesaj = mesaj
        this.dialogyetki = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
    },
    data() {
      return {
        islem: 0,
        mesaj: null,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        dialogyetki: false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


    watch: {

    },
  }




  function beforeMount() {

  }
</script>